/*
 * mod='msgNotify'
 * author: v_xmdjliu
 * time: 2019-02-21
 */

import { smb_fetch, getAgpApiUrl } from "@/api/operator/fetch"

const getApiUrl = (act) => {
  const result = getAgpApiUrl("message", act)

  return result
}

/**
 * 获取消息列表
 * @return
 */

export const getMsgList = (data) => {
  const url = getApiUrl("get_list")
  const params = $.extend(
    true,
    {
      method: "GET",
    },
    data
  )

  return smb_fetch(url, params)
}

/**
 * 改变消息状态
 * @return
 */

export const changeMsgStatus = (data) => {
  const url = getApiUrl("read")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}

/**
 * 删除消息
 * @return
 */

export const deleteMsg = (data) => {
  const url = getApiUrl("delete")
  const params = $.extend(
    true,
    {
      method: "POST",
    },
    data
  )

  return smb_fetch(url, params)
}

export default {
  getMsgList,
  deleteMsg,
  changeMsgStatus,
}
